import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";
import { Preference } from "../prefence/type";
import { UserPreference } from "../userPreference/type";

export const userPreferenceListLoader: LoaderFunction = async () => {
  const available = await axiosApi.get<Result<Preference[]>>(
    "/api/preferences/list-for-user"
  );
  const userPrefs = await axiosApi.get<Result<UserPreference[]>>(
    "/api/userPreferences/list-for-user"
  );

  return {
    preferenceList: available.data.data,
    userPreferenceList: userPrefs.data.data,
  };
};
